import { render, staticRenderFns } from "./AssignedClassSettingDetail.vue?vue&type=template&id=0608ee5f&scoped=true&"
import script from "./AssignedClassSettingDetail.vue?vue&type=script&lang=js&"
export * from "./AssignedClassSettingDetail.vue?vue&type=script&lang=js&"
import style0 from "./AssignedClassSettingDetail.vue?vue&type=style&index=0&id=0608ee5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0608ee5f",
  null
  
)

export default component.exports